<script setup lang="ts">
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';

import { ref } from 'vue';

import { useDataSync } from '../composables/useDataSync';

const { isLoading, syncData } = useDataSync();

const isModalShow = ref(false);
</script>

<template>
  <Button
    v-tooltip.bottom="'Aktualizuj dane'"
    class="!bg-transparent hover:!bg-slate-800"
    severity="secondary"
    text
    icon
    @click="isModalShow = true"
  >
    <i class="pi pi-sync !text-xl text-white" />
  </Button>

  <Dialog
    v-model:visible="isModalShow"
    modal
    header="Czy na pewno chcesz zsynchronizować dane?"
    :style="{ width: '50%', 'max-width': '40rem' }"
  >
    <p class="mb-4">
      Wszystkie lokalne dane zostaną usunięte i zastąpione najnowszymi danymi z serwera. Utracisz
      niezapisane zmiany.
    </p>

    <div class="flex justify-end gap-2 font-semibold">
      <Button size="small" severity="secondary" outlined @click="isModalShow = false">
        Anuluj
      </Button>

      <Button size="small" :loading="isLoading" @click="syncData()"> Aktualizuj </Button>
    </div>
  </Dialog>
</template>
